import {
  TextField,
  NativeSelect,
  Button,
  Alert,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { MEMBERSHIP_ROLES, POLITICAL_ROLES } from "@/constants/roles";
import { SYS_ADMIN_AFFILIATE } from "@/constants/systemAdminAffiliateName";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";
import { canManageAllUsers } from "@/utils/permissionsHandler";

function UserInvitationForm({
  handleClose,
  onTextfieldChangeHandler,
  setChosenAffiliate,
  setChosenRole,
  disableForm,
  inviteUserHandler,
  user,
  affiliates,
  chosenRole,
  chosenAffiliate,
  errorMessages,
}) {
  const [affiliateOptions, setAffiliateOptions] = useState(affiliates);
  const { workflow } = useUpdateDataContext();
  const roles = workflow === "membership" ? MEMBERSHIP_ROLES : POLITICAL_ROLES;

  useEffect(() => {
    setAffiliateOptions(
      affiliates.filter((affiliate) => affiliate.name !== SYS_ADMIN_AFFILIATE)
    );
  }, [affiliates]);

  const chooseAffiliate = (value) => {
    const affiliate = affiliates.find((item) => item.id === value);
    setChosenAffiliate(affiliate);
  };

  return (
    <div>
      <Typography variant="body1">Send an invitation to:</Typography>
      <div className="users-modal-textfields">
        <TextField
          label="name"
          name="name"
          aria-label="name"
          aria-required="true"
          onChange={onTextfieldChangeHandler}
        />
        <TextField
          label="email"
          name="email"
          aria-label="email"
          aria-required="true"
          onChange={onTextfieldChangeHandler}
        />
        {canManageAllUsers(user) && (
          <NativeSelect
            onChange={(e) => setChosenRole(e.target.value)}
            value={chosenRole}
            data-testid="role-select"
          >
            <option value="">choose role</option>
            {roles.map((role, index) => {
              return (
                <option key={`role-${index}`} value={role}>
                  {role}
                </option>
              );
            })}
          </NativeSelect>
        )}
        {canManageAllUsers(user) && (
          <NativeSelect
            key={`affiliate-chooser-${Math.random() * 1000}`}
            onChange={(e) => chooseAffiliate(e.target.value)}
            value={chosenAffiliate?.id}
            data-testid="affiliate-select"
          >
            <option value={{}}>choose affiliate</option>
            {affiliateOptions.map((affiliate, index) => {
              return (
                <option key={`affiliate-${index}`} value={affiliate.id}>
                  {affiliate.display_name}
                </option>
              );
            })}
          </NativeSelect>
        )}
      </div>
      {errorMessages.length !== 0 && (
        <Alert severity="warning" className="users-form-warning">
          {errorMessages.map((item, index) => {
            return <div key={`invite-warnings-${index}`}>{item}</div>;
          })}
        </Alert>
      )}
      <div className="users-modal-buttons">
        <Button className="siteBlueOutlined" onClick={handleClose}>
          cancel
        </Button>
        <Button
          disabled={disableForm}
          className="siteBlue"
          onClick={inviteUserHandler}
        >
          send invite
        </Button>
      </div>
    </div>
  );
}
UserInvitationForm.propTypes = {
  handleClose: PropTypes.func,
  onTextfieldChangeHandler: PropTypes.func,
  setChosenAffiliate: PropTypes.func,
  setChosenRole: PropTypes.func,
  disableForm: PropTypes.bool,
  inviteUserHandler: PropTypes.func,
  user: PropTypes.object,
  affiliates: PropTypes.array,
  chosenRole: PropTypes.string,
  chosenAffiliate: PropTypes.object,
  errorMessages: PropTypes.array,
};
export default UserInvitationForm;
